export default {
  brand: 'speedy',
  name: 'Speedy',
  colors: {
    primary: '#1ec2cf',
    secondary: '#003651',
    'secondary-highlighted-font': '#FFFFFF',
    'secondary-button-font': '#FFFFFF',
  },
  images: {
    logo: 'speedy/logo.svg',
    footerLogo: 'speedy/footer-logo.png',
    homeMain: 'speedy/homepage/zuckerberg-turquoise.png',
    homeSteps1: 'speedy/homepage/step1.png',
    homeSteps2: 'speedy/homepage/step2.png',
    homeSteps3: 'speedy/homepage/step3.png',
    homeSteps4: 'speedy/homepage/step4.png',
    homeUsp1: 'speedy/homepage/convenience.png',
    homeUsp2: 'speedy/homepage/robust.png',
    homeUsp3: 'speedy/homepage/support.png',
    homeUsp4: 'speedy/homepage/easyupdates.png',
    homeButtonTitleOne: 'old_mutual/homepage/placeholder.png',
    homeButtonTitleTwo: 'old_mutual/homepage/placeholder.png',
    homeButtonTitleThree: 'old_mutual/homepage/placeholder.png',
    homeButtonTitleFour: 'old_mutual/homepage/placeholder.png',
    homeAbout1: 'speedy/homepage/stella_ceo.png',
    homeAbout2: 'speedy/homepage/FairbridgesLogo.png',
    overviewStep1: 'speedy/overview/about_yourself.svg',
    overviewStep2: 'speedy/overview/people.svg',
    overviewStep3: 'speedy/overview/assets.svg',
    overviewStep4: 'speedy/overview/sparkly_btc.svg',
    overviewStep5: 'speedy/overview/remainder1.svg',
    overviewStep6: 'speedy/overview/letter_of_wishes.svg',
    overviewStep7: 'speedy/overview/insurance.png',
    aboutYourselfPage: 'speedy/overview/about_yourself.svg',
    assetsPage: 'speedy/overview/remainder1.svg',
    worldWideAssetsPage: 'speedy/overview/remainder1.svg',
    pageNotFound: 'speedy/overview/pet_bostie.svg',
    insuranceAgeRestrictedPage: 'speedy/overview/charity_pig.svg',
    estimatedInsuranceRequiredPage: 'speedy/insurance/estimated-insurance-required.png',
    estimatedInsuranceRequiredInputPage: 'speedy/insurance/estimated-insurance-required-input.png',
    estimatedInsuranceRequiredOutputPage: 'speedy/insurance/estimated-insurance-required-output.png',
    insuranceBankingDetailsPage: 'speedy/insurance/banking-details.png',
    insuranceExplanationPage: 'speedy/insurance/explanation.png',
    insuranceQuestionsPage: 'speedy/insurance/questions.png',
    insuranceNonSACitizenPage: 'speedy/overview/charity_pig.svg',
    insuranceRequestAdvisorCallPage: 'speedy/insurance/explanation.png',
    letterOfWishesPage: 'speedy/overview/letter_of_wishes.svg',
    livingWillPage: 'speedy/overview/living_will.png',
    manageAccountPage: 'speedy/overview/about_yourself.svg',
    peopleOverviewPage: 'speedy/overview/people.svg',
    peopleOverviewSpouse: 'speedy/overview/spouse.svg',
    peopleOverviewChildren: 'speedy/overview/guardian.svg',
    peopleOverviewExecutor: 'speedy/overview/executor.svg',
    peopleOverviewHeir: 'speedy/overview/heir.svg',
    peopleOverviewCharities: 'speedy/overview/charity_box.svg',
    peopleOverviewTrusts: 'speedy/overview/charity_pig.svg',
    distributionSpecificPercentageAlternativesPage: 'speedy/overview/remainder1.svg',
    assetDonationPage: 'speedy/overview/assets.svg',
    moneyDonationPage: 'speedy/overview/money_1.svg',
    specificDonationsPageAssets: 'speedy/overview/assets.svg',
    specificDonationsPageMoney: 'speedy/overview/money_1.svg',
    activateAccountPageMain: 'speedy/activation-landing-page/house_and_funeral.svg',
    activateAccountPage1: 'speedy/activation-landing-page/will.svg',
    activateAccountPage2: 'speedy/activation-landing-page/rand_money.svg',
    activateAccountPage3: 'speedy/activation-landing-page/tombstone.svg',
    activateAccountPage4: 'speedy/activation-landing-page/sold_house.svg',
    activateAccountPage5: 'speedy/activation-landing-page/will_being_read.svg',
    activateAccountPage6: 'speedy/activation-landing-page/executor.svg',
    executorExplainerMain: 'speedy/executor/quinton.svg',
    executorExplainerHowDoesItWork1: 'speedy/executor/post_box.svg',
    executorExplainerHowDoesItWork2: 'speedy/executor/coffin.svg',
    executorExplainerHowDoesItWork3: 'speedy/executor/nomination_form.svg',
    executorExplainerHowDoesItWork4: 'speedy/executor/post_box_letter.svg',
    executorExplainerEstateAdminPartner: 'speedy/executor/ashmanslogo.png',
    advisorPageMain: 'speedy/advisor-page/quinton.svg',
    advisorPageWhyUseUs1: 'speedy/advisor-page/marketing_sharing.svg',
    advisorPageWhyUseUs2: 'speedy/advisor-page/bostie_and_leash.svg',
    advisorPageWhyUseUs3: 'speedy/advisor-page/scale.svg',
    advisorPageWhyUseUs4: 'speedy/advisor-page/executor.svg',
    advisorPageWhyUseUs5: 'speedy/advisor-page/dashboard.svg',
  },
  homeUrl: 'getspeedy.io',
  pageTitle: 'Create Your Will Online | Quick And Easy',
  facebookPageUrl: 'https://www.facebook.com/getspeedy',
  linkedInPageUrl: 'https://www.linkedin.com/company/getspeedy',
  contactAddress: '202 Somewhere Lane',
  contactAddressRedesign: "Mutualpark, \nJan Smuts Drive, \nPinelands, \n7405",
  contactTelNumber: '+27 11 084 7735',
  contactEmail: 'hello@getspeedy.io',
  FAQUrl: 'https://getspeedy.io/frequently-asked-questions/',
  blogUrl: 'https://getspeedy.io/blog/',
  homeAboutTextBlurb1: ``,
  homeAboutTextBlurb2: ``,
  meta: [
    { name: 'description', content: 'Speedy is the quickest way to create your will online and choose an Executor. Get started now.' },
  ],
  internalExecutorName: 'Speedy Estate Administrators',
  executorExplainerExperienceBlurb: ``,
  executorExplainerLargeVolumesBlurb: ``,
  insurancePolicyName: 'Speedy Estate Plan',
  insuranceCallUsTel: '+27 76 630 7344',
  eftPaymentAccountName: 'Speedy Wills (Pty) Ltd',
  eftPaymentAccountNumber: '62811189544',
  eftPaymentBankName: 'Standard Bank',
  eftPaymentPopEmail: 'accounts@getspeedy.io',
  cancelSubscriptionEmail: 'cancel@getspeedy.io',
  advisorPageGetInTouchEmail: 'hello@getspeedy.io',
  estateAssistEnabled: false,
  sso: {
    googleSsoEnabled: false,
    googleClientId: '311768930697-alolgso3c0ip6n8npne6s30cf7vsknqg.apps.googleusercontent.com',
    facebookSsoEnabled: false,
    facebookAppId: ''
  },
}
